export default "__VITE_ASSET__C9sAWvcD__"